import React from "react";

import { TestClaimFormattedRejectCodes } from "@/types/appTypes/transmissions";

import { RejectCodesBox } from "../RejectCodesBox";

const ResponseRejectCodeSegment: React.FC<TestClaimFormattedRejectCodes> = (props: TestClaimFormattedRejectCodes) => {
  const { rejectCodes } = props;

  if (!rejectCodes || (rejectCodes && rejectCodes.length === 0)) {
    return null;
  }

  return (
    <div className="response-segment" data-testid="test__response-segment">
      <div className="segment-name" data-testid="test__segment-name">
        Reject Codes
      </div>
      <div>
        <RejectCodesBox
          rejectCodes={rejectCodes}
          type="warning"
          testId="test__response-reject-code-segment"
          extraClasses="test-claim-message caprx-h-bold-text"
          shadow={false}
          alignText="left"
        />
      </div>
    </div>
  );
};

export default ResponseRejectCodeSegment;
